<template>
  <div
    class="c-favorite"
    @click="toggle"
    :class="{ 'c-favorite--checked': isChecked }"
  >
    <o-icon icon="favorite"/>
  </div>
</template>

<script>
export default {
  name: 'OFavoriteToggle',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isChecked: this.checked
    }
  },
  methods: {
    toggle () {
      this.isChecked = !this.isChecked
    }
  }
}
</script>

<style lang="scss">
.c-favorite {
  .c-icon svg * {
    fill: none;
    stroke: $primary-color;
    stroke: var(--primary-color);
    stroke-width: 0.1rem;
  }
}

.c-favorite--checked {
  .c-icon svg * {
    fill: $primary-color;
    fill: var(--primary-color);
  }
}
</style>
